/* global JWPLAYER_LICENSE_KEY */
import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { walkthroughDispatchers as dispatchers } from 'reduxModules/users/dispatchers'

import JWPlayer from '@jwplayer/jwplayer-react'

import './styles.css'

const VIDEO_ROOT = 'https://d35pwikzwzmbep.cloudfront.net/videos/about/'

// SPEC-113: two edits of the walkthrough. A member on a free trial gets the
// free-trial one; everyone else (paid, Lifetime, gift, or no subscription in
// the store) gets the paid one. Each edit has its own captions and chapters.
export const WALKTHROUGH_VIDEOS = {
  trial: `${VIDEO_ROOT}2026-10-EXPLAINER-VID-free-trial`,
  paid: `${VIDEO_ROOT}2026-10-EXPLAINER-VID-paid`
}

export const walkthroughPlaylist = (onTrial) => {
  const base = onTrial ? WALKTHROUGH_VIDEOS.trial : WALKTHROUGH_VIDEOS.paid
  return {
    sources: [{ file: `${base}-Hi.mp4` }],
    tracks: [
      { file: `${base}-en.vtt`, kind: 'captions', label: 'English' },
      { file: `${base}-es.vtt`, kind: 'captions', label: 'Spanish' },
      { file: `${base}-chapters.vtt`, kind: 'chapters' }
    ]
  }
}

export function WalkthroughVideo(props) {
  const [player, setPlayer] = useState(null)
  // chosen once at mount: the store already holds the persisted subscription,
  // and a later refresh must not swap the video under the viewer
  const [playlist] = useState(() => walkthroughPlaylist(props.onTrial))
  const onReadyCallback = (status) => {
    if (status?.type === 'ready')
      player.on('play', () => props.updateWatchedWalkthrough())
  }
  const didMountCallback = ({ player }) => {
    setPlayer(player)
  }

  return (
    <article className="wrapper" id="WalkthroughVideo">
      <section className="heading">
        <h1>Walkthrough</h1>
      </section>
      <section className="walkthrough-video">
        <div className="player-container">
          <JWPlayer
            library="../../global/vendor/jwplayer-8.48.1/jwplayer.js"
            config={{
              key: JWPLAYER_LICENSE_KEY,
              width: '100%',
              height: '100%',
              autostart: true
            }}
            didMountCallback={didMountCallback}
            onReady={onReadyCallback}
            playlist={playlist}
          />
        </div>
        <p className="walkthrough-video__description">
          <b>Everything you need to know, all in one short video.</b> This quick
          walkthrough shows you how to navigate your account, find and watch
          courses, follow skill-building Learning Pathways, bookmark lessons,
          access materials lists, explore exclusive behind-the-scenes content,
          join the community forums, and get support anytime.
        </p>
        <div className="start-learning-container">
          <Link to="/tutorials" className="btn -orange">
            Start Learning
          </Link>
        </div>
      </section>
    </article>
  )
}

WalkthroughVideo.propTypes = {
  onTrial: PropTypes.bool,
  updateWatchedWalkthrough: PropTypes.func.isRequired
}

WalkthroughVideo.defaultProps = {
  onTrial: false
}

// the same reading of the subscription as the Thank You page
const mapStateToProps = (state) => ({
  onTrial: Boolean(state.auth.subscription?.onTrial)
})

export default connect(mapStateToProps, dispatchers)(WalkthroughVideo)
